export const css = {
    root: 'EXE9dg31',
    title: 'k6yVwhx7',
    content: '-H8qnizR',
    body: 't8U2JvlB',
    ' _key': 'ml/studyplan'
};
export default css;
